/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cookieRef[_ngcontent-%COMP%]{font-family:sofiapro-light,sans-serif;font-size:12px;margin-left:16px;margin-bottom:8px;text-decoration:none;color:#fff;opacity:50%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/navigation/sidenav/sidenav.component.scss.shim.ngstyle.js.pre-build-optimizer.js